const themeDarkBackgroundShading = 'rgba(38, 38, 41, 0.67)';

export { themeDarkBackgroundShading };
